// Official-style store badges as crisp inline SVGs (no external assets).
const FONT = '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';

export function AppStoreBadge({ className = "" }) {
  return (
    <svg
      viewBox="0 0 180 54"
      className={className}
      role="img"
      aria-label="Download on the App Store"
    >
      <rect x="1" y="1" width="178" height="52" rx="10" fill="#000" stroke="rgba(255,255,255,0.28)" strokeWidth="1" />
      {/* Apple logo */}
      <g transform="translate(16,14) scale(1.25)" fill="#fff">
        <path d="M13.62 10.14c-.01-1.63.73-2.86 2.22-3.77-.83-1.19-2.09-1.85-3.74-1.98-1.56-.12-3.27.91-3.89.91-.66 0-2.17-.87-3.36-.87C.99 4.4-.01 6.08 0 8.42c.01 1.18.23 2.4.66 3.66.57 1.65 2.62 5.7 4.76 5.63 1.12-.03 1.91-.8 3.37-.8 1.42 0 2.15.8 3.36.8 2.16-.03 4.01-3.71 4.56-5.37-2.9-1.37-2.75-4.01-2.75-4Zm-2.4-6.93c1.16-1.37.96-2.62.93-3.07-.9.05-1.94.61-2.53 1.3-.65.74-1.03 1.65-.95 2.74.97.07 1.86-.43 2.55-.97Z" />
      </g>
      <text x="47" y="21" fill="#fff" fontFamily={FONT} fontSize="8.5" letterSpacing="0.3">
        Download on the
      </text>
      <text x="46" y="41" fill="#fff" fontFamily={FONT} fontSize="19.5" fontWeight="600">
        App Store
      </text>
    </svg>
  );
}

export function GooglePlayBadge({ className = "" }) {
  return (
    <svg
      viewBox="0 0 180 54"
      className={className}
      role="img"
      aria-label="Get it on Google Play"
    >
      <rect x="1" y="1" width="178" height="52" rx="10" fill="#000" stroke="rgba(255,255,255,0.28)" strokeWidth="1" />
      {/* Google Play triangle */}
      <g transform="translate(17,15.5) scale(1.05)">
        <path d="M0 0 L10.6 10 L0 20 Z" fill="#00C3FF" />
        <path d="M0 0 L14.2 6.4 L10.6 10 Z" fill="#00E676" />
        <path d="M14.2 6.4 L18 10 L14.2 13.6 L10.6 10 Z" fill="#FFCE00" />
        <path d="M0 20 L14.2 13.6 L10.6 10 Z" fill="#FF3B30" />
      </g>
      <text x="50" y="21" fill="#fff" fontFamily={FONT} fontSize="8" letterSpacing="1.4">
        GET IT ON
      </text>
      <text x="49" y="41" fill="#fff" fontFamily={FONT} fontSize="18.5" fontWeight="600">
        Google Play
      </text>
    </svg>
  );
}
